import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation UserSentTestCertEmail($uid: String!){
        ca_send_test_cert_email (uid: $uid) {
            success
        }
    }
`;

export async function userSentTestCertEmail(uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ ca_send_test_cert_email: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.ca_send_test_cert_email;
}